var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("img", {
          attrs: { src: require("../../../static/icon_voice.png") }
        }),
        _vm._v(" "),
        _vm.isShowFirst
          ? [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("p", { staticClass: "btn-box" }, [
                _c("a", { staticClass: "btn", on: { click: _vm.callClick } }, [
                  _vm._v("我已知晓")
                ])
              ])
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.isShowSecond
          ? [
              _c(
                "div",
                { staticClass: "text-box" },
                [
                  _c("h3", [_vm._v("请输入对练搭档的9位数淘金号:")]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      ref: "add",
                      staticStyle: { "margin-top": "10px" },
                      attrs: { inline: true, model: _vm.add, rules: _vm.rules }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "", prop: "tjkId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "320px" },
                              attrs: {
                                filterable: "",
                                remote: "",
                                clearable: "",
                                "remote-method": _vm.querySearch,
                                placeholder: "输入对练搭档的淘金号"
                              },
                              on: { clear: _vm.onClear, change: _vm.onChange },
                              model: {
                                value: _vm.tjkName,
                                callback: function($$v) {
                                  _vm.tjkName = $$v
                                },
                                expression: "tjkName"
                              }
                            },
                            _vm._l(_vm.userList, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.label, value: item.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-form-item", [
                        !_vm.isPending
                          ? _c(
                              "a",
                              {
                                staticClass: "btn",
                                on: { click: _vm.gotoReady }
                              },
                              [_vm._v("确认")]
                            )
                          : _c("a", { staticClass: "btn" }, [_vm._v("加载中")])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.isShowThird ? [_vm._m(2)] : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-box" }, [
      _c("h3", [_vm._v("对练目的：")]),
      _vm._v(" "),
      _c("p", [_vm._v("1、熟悉小助手外呼操作步骤；")]),
      _vm._v(" "),
      _c("p", [_vm._v("2、与搭档进行话术对练；")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-box" }, [
      _c("h3", [_vm._v("必备条件：")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "1、有对练搭档（一般老师会分组，若未分组，请自行在群内找搭档）；"
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("2、你的对练搭档也进入了语音对练；")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-box" }, [
      _c("h3", [_vm._v("接下来，请按照以下步骤操作：")]),
      _vm._v(" "),
      _c("p", [_vm._v("1、点击“待办任务”，并刷新小助手；")]),
      _vm._v(" "),
      _c("p", [_vm._v("2、完成打卡；")]),
      _vm._v(" "),
      _c("p", [_vm._v("3、签入SIP话机；")]),
      _vm._v(" "),
      _c("p", [_vm._v("4、领取数据；")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "5、进行外呼练习，并填写客户资料（对练话术用培训考试给到的话术）；"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4224f418", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4224f418","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/mobile/voiceExercise.vue
// module id = 1500
// module chunks = 0